import styled, { css } from 'styled-components';

import { getDimension } from 'styled/helpers/getDimension';

export const BannerContainer = styled.div`
  background-color: ${props => props.theme.colors.navyBlue};
  max-width: 500px;
  padding: ${getDimension('size6')};
  position: absolute;
  bottom: 0px;
  left: 0px;
  position: fixed;
  z-index: 1001;
`;

export const CookieInfoContainer = styled.div`
  max-height: 400px;
  margin-bottom: ${getDimension('size6')};
  overflow: scroll;

  /* Hides the default scroll-bar on Chrome, Sarafi, and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Hides scroll-bar on IE and Edge */
  scrollbar-width: none; /* Hides scroll-bar on Firefox */
`;

export const Header = styled.h4`
  color: ${props => props.theme.colors.white};
`;

export const Text = styled.p<{ bold?: boolean; noMargin?: boolean }>`
  color: ${props => props.theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.sm};

  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `}
`;
